<template>
  <div class="checkout-credit-card">
    <mdc-grid-container>
      <mdc-grid>
        <mdc-grid-cell :cols="12">
          <mdc-text-field
            v-model="value.name"
            label="Name on card"
            name="ccname"
            autocomplete="cc-name"
            required
            @input="onCreditCardFieldChange('name', $event)"
            @validity="onCreditCardFieldValidityChange('name', $event)"
          />
        </mdc-grid-cell>
        <mdc-grid-cell :cols="12">
          <mdc-text-field
            v-model="value.number"
            label="Credit Card Number"
            name="cardnumber"
            autocomplete="cc-number"
            :maxlength="19"
            :validate="validateCardNumber"
            :trailing-icon="paymentMethodIcon"
            trailing-icon-type="image"
            required
            @input="onCreditCardNumberChange"
            @validity="onCreditCardValidity"
          />
        </mdc-grid-cell>
        <mdc-grid-cell :layout="responsiveLayout">
          <mdc-text-field
            v-model="value.expiry"
            label="Exp Date"
            name="exp-date"
            autocomplete="cc-exp"
            :minlength="5"
            :maxlength="5"
            :validate="validateExpiry"
            :format="formatExpiry"
            required
            @input="onCreditCardFieldChange('expiry', $event)"
            @validity="onCreditCardFieldValidityChange('expiry', $event)"
          />
        </mdc-grid-cell>
        <mdc-grid-cell :layout="responsiveLayout">
          <mdc-text-field
            v-model="value.cvc"
            label="CVC"
            name="cvc"
            autocomplete="cc-csc"
            :validate="validateCVC"
            :maxlength="4"
            required
            @input="onCreditCardFieldChange('cvc', $event)"
            @validity="onCreditCardFieldValidityChange('cvc', $event)"
          />
        </mdc-grid-cell>
        <mdc-grid-cell :layout="responsiveLayout">
          <mdc-text-field
            v-model="value.zip"
            label="ZIP"
            :validate="validateZIP"
            required
            @input="onCreditCardFieldChange('zip', $event)"
            @validity="onCreditCardFieldValidityChange('zip', $event)"
          />
        </mdc-grid-cell>
      </mdc-grid>
    </mdc-grid-container>
  </div>
</template>

<script>
import MdcGrid from '../material/Grid'
import MdcGridCell from '../material/GridCell'
import MdcGridContainer from '../material/GridContainer'
import MdcTextField from '../material/TextField'
import loadStripe from '../../lib/stripe'
import paymentMethodIcon from './icons/payment_methods'
import { isPostalCode } from 'validator'

export function creditCard (defaults = {}) {
  return {
    name: '',
    number: '',
    expiry: '',
    cvc: '',
    zip: '',
    type: '',
    ...defaults
  }
}

export default {
  components: {
    MdcGrid,
    MdcGridCell,
    MdcGridContainer,
    MdcTextField
  },
  props: {
    value: {
      type: Object,
      default () {
        return creditCard()
      }
    }
  },
  data () {
    return {
      responsiveLayout: [
        { device: 'phone', columns: 4 },
        { device: 'tablet', columns: 2 }
        // { device: 'desktop', columns: 4 }
      ],
      paymentMethodIcon: paymentMethodIcon({ method: 'unknwon' })
    }
  },
  async mounted () {
    this.Stripe = await loadStripe()
  },
  methods: {
    validateCardNumber (cardNumber) {
      return {
        valid: !!cardNumber && this.Stripe.validateCardNumber(cardNumber),
        message: 'Card number is invalid'
      }
    },
    validateExpiration (cardNumber) {
      return {
        valid: !!cardNumber && this.Stripe.validateCardNumber(cardNumber),
        message: 'Invalid card number'
      }
    },
    validateExpiry (date) {
      return {
        valid: !!date && this.Stripe.validateExpiry(date),
        message: 'Invalid expiry date'
      }
    },
    validateCVC (cvc) {
      return {
        valid: !!cvc && this.Stripe.validateCVC(cvc),
        message: 'Invalid cvc number'
      }
    },
    validateZIP (zip) {
      return {
        valid: !!zip && isPostalCode(zip, 'any'),
        message: 'Invalid zip code'
      }
    },
    // simulates behavior found in stripe elements
    formatExpiry (date) {
      date = date.trim()

      if (date === '0' || date === '1') {
        return date
      }

      if (date.length === 1) {
        return `0${date}/`
      }

      if (date.length === 2) {
        return `${date}/`
      }

      return date
    },
    onCreditCardNumberChange (cardNumber) {
      this.value.type = this.Stripe.card.cardType(cardNumber)
      this.onCreditCardFieldChange('number', cardNumber)
      this.paymentMethodIcon = paymentMethodIcon({
        method: this.value.type
      })
    },
    onCreditCardValidity ({ valid, message }) {
      if (!valid) {
        this.paymentMethodIcon = paymentMethodIcon({
          method: 'error'
        })
      }
      this.onCreditCardFieldValidityChange('number', { valid, message })
    },
    onCreditCardFieldChange (field, value) {
      this.$emit('input', this.value)
    },
    onCreditCardFieldValidityChange (field, { valid, message }) {
      this.$emit('validity', { field, valid, message })
    }
  }
}
</script>

<style lang="scss">
</style>
